/* eslint-disable */
var index = 0;
function Tip(obj) {
    this.id = index++;
    this.msg = obj.msg;
    this.className = obj.className || '';
    this.el = null;
    this.during = obj.during || 3000;
}
Tip.prototype.info = function () {
    this.el = this.create();
    setTimeout(() => {
        this.hide();
    }, this.during);
};
Tip.prototype.infoInCenter = function () {
    this.el = this.createCenterTip();
    setTimeout(() => {
        this.hide();
    }, this.during);
};

Tip.prototype.create = function () {
    // 小米手机style属性不生效 多加一层
    var el = document.createElement('div');
    el.setAttribute('data-ids', this.id);
    el.innerHTML = `<div class="${this.className}" style="position: fixed; top: 0.16rem; right: 0; left: 0; text-align: center; z-index: 1999;"><span style="display: inline-block; margin: 0 auto;  background: rgba(0, 0, 0, 0.8); border-radius: 6px; margin: 0 .1rem; padding: 0.17rem 0.25rem; font-size: .13rem; color: #fff;">${this.msg}</span></div>`;
    document.body.appendChild(el);
    return el;
};
Tip.prototype.createCenterTip = function () {
    // 小米手机style属性不生效 多加一层
    var el = document.createElement('div');
    el.setAttribute('data-ids', this.id);
    el.innerHTML = `<div class="${this.className}" style="position: fixed; top: 50%; right: 0; left: 0; text-align: center; z-index: 1999;"><span style="display: inline-block; margin: 0 auto;  background: rgba(0, 0, 0, 0.8); border-radius: .2rem; margin: 0 .1rem; padding: 0.07rem 0.15rem; font-size: .13rem; color: #fff;">${this.msg}</span></div>`;
    document.body.appendChild(el);
    return el;
};
Tip.prototype.hide = function () {
    document.body.removeChild(this.el);
    this.el = null;
};

export default {
    info(msg, params) {
        var tip = new Tip({ msg, ...params });
        tip.info();
    },
    infoInCenter(msg, params) {
        var tip = new Tip({ msg, ...params });
        tip.infoInCenter();
    }
};
